// We can have edit, duplicate or the form for creating a record.
// For creating, we do not read the 'new' key from the url for now, so that's why 'default' is being used for 'new'
// We could opt for 'new', but in that case we will have to add the reading of 'new' from the url and perform some
// changes within the app to make sure we are in 'new' mode.
export enum FormActionTypeEnum {
	edit = 'edit',
	duplicate = 'duplicate',
	newFrom = 'newFrom',
	default = 'default'
}
